import React, { PureComponent } from 'react'
import userActions from '../redux/actions/userActions'
import { bindActionCreators, AnyAction, Dispatch } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Game from '../connectors/game/Game'
import TeacherGame from '../connectors/teacherGame/TeacherGame'
import TeacherWinners from '../connectors/teacherWinners/TeacherWinners'
import Login from '../connectors/login/Login'
import Setup from '../connectors/setup/Setup'
import Splash from '../connectors/splash/Splash'
import Waiting from '../connectors/waiting/Waiting'
import Winners from '../connectors/winners/Winners'
import Preview from '../connectors/preview/Preview'
import NotSupported from '../connectors/notSupported/NotSupported'
import viewTypes from '../helpers/enums/views'
import viewSelector from '../redux/selectors/app/viewSelector'
import { IStore } from '../redux/reducers/index'
import getFont from '../helpers/fonts/fonts'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
`

interface IViewsManagerProps {
	view?: string
	userInteracted: boolean
	userInteractionUpdate: () => void
}

class ViewsManager extends PureComponent<IViewsManagerProps> {
	unmuteGame = () => {
		if (!this.props.userInteracted) {
			this.props.userInteractionUpdate()
		}
	}
	render() {
		return (
			<Wrapper style={{ fontFamily: getFont('primaryRegular') }} onMouseDown={this.unmuteGame}>
				{<NotSupported shouldRender={this.props.view === viewTypes.NOT_SUPPORTED} />}
				{<Splash shouldRender={this.props.view === viewTypes.SPLASH} />}
				{<Login shouldRender={this.props.view === viewTypes.LOGIN} />}
				{<Setup shouldRender={this.props.view === viewTypes.SETUP} />}
				{<Waiting shouldRender={this.props.view === viewTypes.CAMP} />}
				{<Game shouldRender={this.props.view === viewTypes.GAME} />}
				{<TeacherGame shouldRender={this.props.view === viewTypes.TEACHER_GAME} />}
				{<TeacherWinners shouldRender={this.props.view === viewTypes.TEACHER_WINNERS} />}
				{<Winners shouldRender={this.props.view === viewTypes.WINNERS} />}
				{<Preview shouldRender={this.props.view === viewTypes.PREVIEW} />}
			</Wrapper>
		)
	}
}
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
	return bindActionCreators(
		{
			userInteractionUpdate: userActions.userInteractionUpdate,
		},
		dispatch
	)
}

const mapStateToProps = (state: IStore) => {
	return viewSelector(state)
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewsManager)
